// Import files here. This is the main lib entry point.
// You can use ES5, or ES6 here.
import $ from "jquery";
const jQuery = $;


function anchorScroll(this_obj, that_obj, base_speed, offset) {
    console.log("anchorScroll called with:", {
        this_obj: this_obj,
        that_obj: that_obj,
        base_speed: base_speed,
        offset: offset
    });
    
    var that_offset = that_obj.offset();
    console.log("Target offset:", that_offset);

    // Instant scroll - no animation, no pause
    $("html,body").scrollTop(that_offset.top - offset);
    
    console.log("Instant scroll completed");
}


$(document).ready(function () {
    console.log("Document ready, setting up navigation click handlers");
    
    // Handle hash in URL on page load
    if (window.location.hash) {
        var hash = window.location.hash;
        var targetElement = $('[data-element-id="' + hash.substring(1) + '"]');
        
        if (targetElement.length > 0) {
            // Wait a bit for page to fully load, then scroll
            setTimeout(function() {
                var headerHeight = $('header#main').outerHeight() || 0;
                var isMobile = window.innerWidth < 992;
                var finalOffset = isMobile ? 200 : headerHeight;
                
                console.log("Auto-scrolling to hash:", hash, "Offset:", finalOffset);
                $("html,body").scrollTop(targetElement.offset().top - finalOffset);
            }, 500);
        }
    }
    
    // Handle ALL contact links on the page (header, navigation, anywhere)
    $('a[href="#contact"]').click(function(e) {
        e.preventDefault();
        var targetElement = $('[data-element-id="contact"]');
        
        if (targetElement.length > 0) {
            var headerHeight = $('header#main').outerHeight() || 0;
            var isMobile = window.innerWidth < 992;
            var finalOffset = isMobile ? 200 : headerHeight;
            
            console.log("Contact link clicked, scrolling to contact section");
            $("html,body").scrollTop(targetElement.offset().top - finalOffset);
        }
    });
    
    $("#bs4navbar .nav-link").click(function (e) {
        var href = $(this).attr("href");
        console.log("Nav link clicked:", href);
        
        // Check if it's an internal anchor link (starts with #)
        if (href && href.startsWith('#')) {
            e.preventDefault(); // Prevent default navigation
            console.log("Preventing default navigation for:", href);
            
            // Check if the target element exists
            var targetElement = $('[data-element-id="' + href.substring(1) + '"]');
            console.log("Target element found:", targetElement.length > 0);
            
            if (targetElement.length > 0) {
                // Calculate offset (header height) - responsive for mobile
                var headerHeight = $('header#main').outerHeight() || 0;
                var isMobile = window.innerWidth < 992; // lg breakpoint (md and down)
                
                // Use smaller offset for mobile, full header height for desktop
                var finalOffset = isMobile ? 200 : headerHeight;
                
                console.log("Header height:", headerHeight, "Mobile:", isMobile, "Final offset:", finalOffset);
                
                // Close mobile menu if it's open
                var mobileMenu = $('#bs4navbar');
                if (mobileMenu.hasClass('show')) {
                    mobileMenu.removeClass('show');
                    $('.navbar-toggler').addClass('collapsed').attr('aria-expanded', 'false');
                }
                
                // Smooth scroll to the target
                anchorScroll(
                    $(this),
                    targetElement,
                    800,
                    finalOffset
                );
            } else {
                console.log("Target element not found:", href);
            }
        } else {
            console.log("External link, allowing normal navigation");
        }
    });

    (function () {
        var timeout;
        var $window = $(window);
        var $navbar = $('header#main');
        var lastScrollTop = 0;

        $window.on('scroll', function (e) {
            clearTimeout(timeout);

            timeout = setTimeout(function () {
                var currentScrollTop = $window.scrollTop();
                
                // Check if mobile menu is actually open right now
                var isMenuOpen = $('#bs4navbar').hasClass('show');
                
                // Don't hide header if mobile menu is open
                if (isMenuOpen) {
                    return;
                }
                
                // Always show header when at the top
                if (currentScrollTop < 100) {
                    $navbar.removeClass('hide');
                }
                // Show header when scrolling up, hide when scrolling down
                else if (currentScrollTop < lastScrollTop) {
                    // Scrolling up
                    $navbar.removeClass('hide');
                } else if (currentScrollTop > lastScrollTop) {
                    // Scrolling down
                    $navbar.addClass('hide');
                }
                
                lastScrollTop = currentScrollTop;
            }, 150); // Increased delay to prevent conflicts
        });
    }());

    // CF7 Select Default Functionality
    function setupCF7SelectDefaults() {
        // Target only the specific form
        const form = document.querySelector('#wpcf7-f153-o1');
        if (!form) return;
        
        // Find select elements only within this specific form
        const cf7Selects = form.querySelectorAll('.wpcf7-select, .form-select');
        
        cf7Selects.forEach(function(select) {
            // Check if the select has a placeholder option
            const hasPlaceholder = Array.from(select.options).some(option => 
                option.text.toLowerCase().includes('which service') || 
                option.text.toLowerCase().includes('interested') ||
                option.text.toLowerCase().includes('option 1') ||
                option.text.toLowerCase().includes('first_as_label') ||
                option.text.toLowerCase().includes('which service are you interested in')
            );
            
            if (hasPlaceholder) {
                // Set the first option (placeholder) as selected
                select.selectedIndex = 0;
                
                // Disable the first option to prevent selection
                if (select.options[0]) {
                    select.options[0].disabled = true;
                }
            }
        });
    }
    
    // Run CF7 setup when DOM is ready
    setupCF7SelectDefaults();
    
    // Also run after a delay to catch CF7's late initialization
    setTimeout(setupCF7SelectDefaults, 1000);
    setTimeout(setupCF7SelectDefaults, 2000);

});

